import type { SpaceSelectProps as UIKitSpaceSelectProps } from "@circle-react-shared/SpaceSelect";
import { SpaceSelect as UIKitSpaceSelect } from "@circle-react-shared/SpaceSelect";
import { SpaceSelectCompass } from "@circle-react-shared/SpaceSelectCompass";
import type { ReactElement } from "react";

import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

export interface SpaceSelectProps extends UIKitSpaceSelectProps {
  disabled?: boolean;
  layout?: "horizontal" | "vertical";
  trigger?: ReactElement;
}

export const SpaceSelect = ({
  trigger,
  ...props
}: Readonly<SpaceSelectProps>): ReactElement => {
  const isCircleV4 = useIsCircleV4FeatureEnabled(
    "circle_v4_form_elements_enabled",
  );

  if (!isCircleV4) {
    return <UIKitSpaceSelect {...props} />;
  }

  const {
    name = "",
    rules,
    defaultValue,
    onChange,
    spaces,
    shouldDisplayHomepage,
    shouldShowEmoji,
    layout,
    ...passThroughProps
  } = props;

  return (
    <SpaceSelectCompass
      name={name}
      rules={rules}
      defaultValue={defaultValue}
      onChange={onChange}
      spaces={spaces}
      shouldDisplayHomepage={shouldDisplayHomepage}
      shouldShowEmoji={shouldShowEmoji}
      layout={layout}
      trigger={trigger}
      {...passThroughProps}
    />
  );
};

SpaceSelect.displayName = "SpaceSelect";
